import { Mesh } from 'three';
import React from 'react';

export default {
    name: 'north-sign',
    prototype: 'items',

    info: {
        tag: ['north-sign'],
        title: 'North Sign',
        description: 'North Sign',
        image: require('./north-sign.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 75
            }
        },
    },

    render2D: function (element, layer, scene) {
        let width = element.properties.get('width').get('length');

        return (
            <g transform={`scale(${width * 0.02} ${width * 0.02})`}>
                <path d="M0 0 L-10 -10 L0 20 Z" style={{ fill: '#ffffff', stroke: '#000000' }} />
                <path d="M0 0 L10 -10 L0 20 Z" style={{ fill: '#000000', stroke: '#000000' }} />
            </g>

        )


    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
